module.exports = __webpack_public_path__ + "img/Frederick_Arthur_Bridgman_-_An_Interesting_Game.d9c8190a.jpg";